// Function to transform Ninja Forms submit inputs
function transformNinjaSubmitButtons() {
    // Find all Ninja Forms submit inputs
    const submitButtons = document.querySelectorAll(
      'input.ninja-forms-field[type="submit"]'
    );
  
    submitButtons.forEach((submitButton) => {
      // Skip if this button was already transformed
      if (submitButton.dataset.transformed) return;
  
      // Hide the original button immediately
      submitButton.style.display = "none";
  
      // Create wrapper div
      const wrapper = document.createElement("div");
      wrapper.className = "cta-button cta-button--primary";
  
      // Create button element to replace input
      const button = document.createElement("button");
      button.className = "ninja-forms-submit-button";
      button.type = "submit";
      button.name = submitButton.name;
      button.id = submitButton.id + "_styled";
      button.form = submitButton.form ? submitButton.form.id : "";
  
      // Copy all attributes and event handlers
      for (let i = 0; i < submitButton.attributes.length; i++) {
        const attr = submitButton.attributes[i];
        if (
          attr.name !== "type" &&
          attr.name !== "class" &&
          attr.name !== "style" &&
          attr.name !== "id"
        ) {
          button.setAttribute(attr.name, attr.value);
        }
      }
  
      // Create text span
      const textSpan = document.createElement("span");
      textSpan.className = "cta-button__text";
      textSpan.textContent = submitButton.value || "Submit";
  
      // Create icon wrapper
      const iconWrapper = document.createElement("span");
      iconWrapper.className = "cta-button__icon-wrapper";
      iconWrapper.innerHTML =
        '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.66634 10L7.49967 8.79167L10.458 5.83333H0.333008V4.16667H10.458L7.49967 1.20833L8.66634 0L13.6663 5L8.66634 10Z" fill="currentColor"></path></svg>';
  
      // Assemble the elements
      button.appendChild(textSpan);
      button.appendChild(iconWrapper);
      wrapper.appendChild(button);
  
      // Insert the new button immediately after the original
      submitButton.parentNode.insertBefore(wrapper, submitButton.nextSibling);
  
      // Preserve the original button but hide it
      submitButton.dataset.transformed = "true";
  
      // Handle form submission from the new button
      button.addEventListener("click", function (e) {
        e.preventDefault();
        submitButton.click(); // Trigger the original button's click event
      });
    });
  }
  
  // Run immediately without waiting for DOMContentLoaded
  (function () {
    // Initial run
    transformNinjaSubmitButtons();
  
    // Also run on DOMContentLoaded just in case
    document.addEventListener("DOMContentLoaded", transformNinjaSubmitButtons);
  
    // Use polling to check for new buttons every 100ms for the first 5 seconds
    let pollCount = 0;
    const pollInterval = setInterval(function () {
      transformNinjaSubmitButtons();
      pollCount++;
      if (pollCount > 50) {
        // Stop polling after 5 seconds
        clearInterval(pollInterval);
      }
    }, 100);
  
    // Handle AJAX form loading with MutationObserver
    const observer = new MutationObserver(function () {
      transformNinjaSubmitButtons();
    });
  
    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });
  
    // jQuery events for Ninja Forms
    if (typeof jQuery !== "undefined") {
      jQuery(document).on("nfFormReady", transformNinjaSubmitButtons);
      jQuery(document).on(
        "ninja_forms_ajax_complete",
        transformNinjaSubmitButtons
      );
      jQuery(document).on("nfFormSubmitResponse", transformNinjaSubmitButtons);
  
      // Additional events that might help catch form loads
      jQuery(document).ajaxComplete(function () {
        setTimeout(transformNinjaSubmitButtons, 50);
      });
    }
  })();

  // Revinate - Ninja Form Implementation
document.addEventListener('DOMContentLoaded', function() {
    // Wrest Point Ninja Form IDs
    const NINJA_FORMS_CONTACT_PAGE = "11";
    const NINJA_FORMS_NEWSLETTER = "999";
  
    // Revinate public api token
    const REVINATE_TOKEN = "b462e175-2a57-488d-9127-35aebdba03b2";
  
    /**
     * Get the host of this script. The host will be used for posting the data.
     */
    const getHost = function() {
      return "contact-api.inguest.com";
    };
  
    function getFieldByCustomName(responseWrapper, customName) {
      // Check if responseWrapper exists and has the expected structure
      if (
        !responseWrapper ||
        !responseWrapper.response ||
        !responseWrapper.response.data ||
        !responseWrapper.response.data.fields
      ) {
        return null;
      }
  
      const fields = responseWrapper.response.data.fields;
      for (const fieldKey in fields) {
        if (fields.hasOwnProperty(fieldKey)) {
          const field = fields[fieldKey];
          if (field && field.custom_name_attribute === customName) {
            return field;
          }
        }
      }
      return null; // Return null if no matching field is found
    }
  
    function getFormData(form, token, response) {
      const data = { tokens: [token], contacts: [{}] };
      const contact = data.contacts[0];
  
      // Get all form inputs, selects, and textareas
      form.querySelectorAll('input, select, textarea').forEach(function(field) {
        const name = field.getAttribute('name');
        const value = field.value;
  
        switch (name) {
          case "firstName":
            const firstNameField = getFieldByCustomName(response, "firstName");
            if (firstNameField && firstNameField.value) {
              contact.firstName = firstNameField.value;
            }
            break;
          case "lastName":
            const lastNameField = getFieldByCustomName(response, "lastName");
            if (lastNameField && lastNameField.value) {
              contact.lastName = lastNameField.value;
            }
            break;
          case "email":
            contact.email = value;
            if (contact.email === "") {
              const emailField = getFieldByCustomName(response, "email");
              if (emailField && emailField.value) {
                contact.email = emailField.value;
              }
            }
            break;
          // Add more cases here for other fields you want to capture
        }
      });
  
      // Combine first and last name into a single name field
      if (contact.firstName || contact.lastName) {
        contact.name = (
          (contact.firstName || "") +
          " " +
          (contact.lastName || "")
        ).trim();
      }
  
      return data;
    }
  
    function submitContact(postData) {
      const url = "//" + getHost() + "/api/add-contacts-to-lists";
      
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'text/plain'
        }
      })
      .then(response => response.json())
      .then(data => {
        //console.log("*** CONTACT SUBMITTED ***", data);
      })
      .catch(error => {
        //console.error("*** CONTACT SUBMISSION ERROR ***", error);
      });
    }
  
    function createRevinateContact(form_id, response) {
      const formSelector = `#nf-form-${form_id}-cont form`;
      const formElement = document.querySelector(formSelector);
  
      if (!formElement) {
        //console.log("Form not found:", formSelector);
        return;
      }
  
      const data = getFormData(formElement, REVINATE_TOKEN, response);
  
      if (!data.contacts[0].email) {
        //console.log("Email is required");
        return;
      }
  
      submitContact(data);
    }
  
    function handleFormSubmission(form_id, response) {
      //console.log("Handling form submission for form ID:", form_id);
  
      if (
        form_id === NINJA_FORMS_CONTACT_PAGE ||
        form_id === NINJA_FORMS_NEWSLETTER
      ) {
        createRevinateContact(form_id, response);
      } else {
        //console.log("Form submitted, but not one we're tracking:", form_id);
      }
    }
  
    // Use a Set to keep track of processed form submissions
    let processedForms = new Set();
  
    // For jQuery environments
    if (typeof jQuery !== "undefined") {
      // The key fix: Use the proper jQuery event binding format
      jQuery(document).on("nfFormSubmitResponse", function(event, response) {
        //console.log("jQuery nfFormSubmitResponse event captured", response);
        
        if (response && typeof response === "object" && response.id) {
          const formId = response.id;
  
          // Check if this form has already been processed
          if (processedForms.has(formId)) {
            //console.log("Form already processed:", formId);
            return;
          }
  
          // Add the form ID to the set of processed forms
          processedForms.add(formId);
  
          handleFormSubmission(formId, response);
  
          // Remove the form ID from the set after a delay
          setTimeout(() => {
            processedForms.delete(formId);
          }, 5000); // 5 seconds delay
        } else {
          //console.log("Invalid response structure:", response);
        }
      });
      
      // Additional fallback for AJAX requests that might be form submissions
      jQuery(document).ajaxSuccess(function(event, xhr, settings) {
        if (settings.url.includes('ninja-forms') || settings.url.includes('admin-ajax.php')) {
          try {
            const responseData = JSON.parse(xhr.responseText);
            if (responseData && responseData.data && responseData.data.form_id) {
              const formId = responseData.data.form_id;
              
              // Prevent duplicate processing
              if (!processedForms.has(formId)) {
                //console.log("Form submission detected from AJAX success:", formId);
                processedForms.add(formId);
                handleFormSubmission(formId, responseData);
                
                setTimeout(() => {
                  processedForms.delete(formId);
                }, 5000);
              }
            }
          } catch (e) {
            // Not JSON or other error, ignore
          }
        }
      });
    } 
    // For non-jQuery environments
    else {
      // Native DOM event for custom event
      document.addEventListener("nfFormSubmitResponse", function(event) {
        const response = event.detail;
        //console.log("Native nfFormSubmitResponse event captured", response);
        
        if (response && typeof response === "object" && response.id) {
          const formId = response.id;
          
          if (!processedForms.has(formId)) {
            processedForms.add(formId);
            handleFormSubmission(formId, response);
            
            setTimeout(() => {
              processedForms.delete(formId);
            }, 5000);
          }
        }
      });
    }
  
    //console.log("Revinate contact script initialized");
  });

//////////  REVINATE - GRAVITY FORM IMPLEMENTATION //////////////////////

// document.addEventListener("DOMContentLoaded", function () {
//     // Gravity Form IDs
//     const GRAVITY_FORMS_CONTACT_PAGE = 1;
//     const GRAVITY_FORMS_NEWSLETTER = 999;

//     // Revinate public api token
//     // const REVINATE_TOKEN = "5c82d897-96fc-411e-b216-2e89f2d97aea";
//     const REVINATE_TOKEN = "b462e175-2a57-488d-9127-35aebdba03b2";

//     // Store the form data when the form is submitted but before it's processed by Gravity Forms
//     let storedFormData = null;

//     /**
//      * Get the host of this script. The host will be used for posting the data.
//      */
//     const getHost = function () {
//       return "contact-api.inguest.com";
//     };

//     function getFieldByInputName(form, inputName) {
//       const fields = form.querySelectorAll("input, select, textarea");
//       for (const field of fields) {
//         const name = field.getAttribute("name");
//         if (name && name.includes(`input_${inputName}`)) {
//           return field;
//         }
//       }
//       return null;
//     }

//     function getFormData(form, token) {
//       const data = { tokens: [token], contacts: [{}] };
//       const contact = data.contacts[0];

//       // Find common fields by their input name patterns in Gravity Forms
//       // Gravity Forms typically uses input_1, input_2, etc. for field names

//       // First Name - assuming it's in a field with a class containing "first_name"
//       const firstNameField = form.querySelector(".ginput_first");
//       if (firstNameField) {
//         contact.firstName = firstNameField.value;
//       }

//       // Last Name - assuming it's in a field with a class containing "last_name"
//       const lastNameField = form.querySelector(".ginput_last");
//       if (lastNameField) {
//         contact.lastName = lastNameField.value;
//       }

//       // Email - typically has a validation class for email
//       const emailField =
//         form.querySelector('input[type="email"]') ||
//         form.querySelector(".ginput_container_email input");
//       if (emailField) {
//         contact.email = emailField.value;
//       }

//       // Combine first and last name into a single name field
//       if (contact.firstName || contact.lastName) {
//         contact.name = (
//           (contact.firstName || "") +
//           " " +
//           (contact.lastName || "")
//         ).trim();
//       }

//       return data;
//     }

//     function submitContact(postData) {
//       const url = "//" + getHost() + "/api/add-contacts-to-lists";

//       fetch(url, {
//         method: "POST",
//         body: JSON.stringify(postData),
//         headers: {
//           "Content-Type": "text/plain",
//         },
//       })
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error("Network response was not ok");
//           }
//           return response.json();
//         })
//         .then((data) => {
//           // Success handling
//           //////console.error("*** CONTACT SUBMITTED ***", data);
//         })
//         .catch((error) => {
//           // Error handling
//           ////console.error("*** CONTACT SUBMISSION ERROR ***", error);
//         });
//     }

//     function createRevinateContact(formId, formElement) {
//       // Use the stored form data if we have it and no form element was found
//       if (!formElement && storedFormData && storedFormData.formId === formId) {
//         //////console.error("Using stored form data for form ID:", formId);

//         const data = {
//           tokens: [REVINATE_TOKEN],
//           contacts: [{
//             email: storedFormData.email
//           }]
//         };

//         //////console.error("Submitting stored data:", data);
//         submitContact(data);
//         // Clear stored data after use
//         storedFormData = null;
//         return;
//       }

//       if (!formElement) {
//         ////console.error("Form not found for ID:", formId);
//         // Try to find any form with an email input as a fallback
//         const emailInputs = document.querySelectorAll('input[type="email"]');
//         //////console.error("Found email inputs:", emailInputs.length);

//         if (emailInputs.length > 0) {
//           // Use the form containing the first email input found
//           formElement = emailInputs[0].closest('form');
//           //////console.error("Using fallback form:", formElement);
//         }

//         if (!formElement) {
//           ////console.error("No usable form found on page");
//           return;
//         }
//       }

//       // Log form fields for debugging
//       const inputs = formElement.querySelectorAll('input, select, textarea');
//       //////console.error("Form inputs found:", inputs.length);

//       const data = getFormData(formElement, REVINATE_TOKEN);
//       //////console.error("Form data extracted:", data);

//       if (!data.contacts[0].email) {
//         ////console.error("Email is required");
//         return;
//       }

//       submitContact(data);
//     }

//     // Use a Set to keep track of processed form submissions
//     const processedForms = new Set();

//     // Function to handle the gform_confirmation_loaded event
//     function handleGravityFormSubmission(event, formId) {
//       //////console.error("Handling form submission for form ID:", formId);

//       // Convert formId to a number for comparison
//       const formIdNum = parseInt(formId, 10);

//       // Check if this form ID matches the ones we're tracking
//       if (
//         formIdNum === GRAVITY_FORMS_CONTACT_PAGE ||
//         formIdNum === GRAVITY_FORMS_NEWSLETTER
//       ) {
//         // Check if this form has already been processed
//         if (processedForms.has(formId)) {
//           //////console.error("Form already processed:", formId);
//           return;
//         }

//         // Add the form ID to the set of processed forms
//         processedForms.add(formId);

//         // Process the contact - will use stored data if form is not found
//         createRevinateContact(formId, null);

//         // Remove the form ID from the set after a delay
//         setTimeout(() => {
//           processedForms.delete(formId);
//         }, 5000); // 5 seconds delay
//       } else {
//         //////console.error("Form submitted, but not one we're tracking:", formId);
//       }
//     }

//     // Handle the gform_confirmation_loaded event which fires after successful form submission
//     if (window.jQuery) {
//       jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
//         //////console.error("Form confirmation loaded for ID:", formId);
//         //////console.error("Stored form data at confirmation:", storedFormData);

//         // Convert formId to a number for comparison
//         const formIdNum = parseInt(formId, 10);

//         if (formIdNum === GRAVITY_FORMS_CONTACT_PAGE ||
//             formIdNum === GRAVITY_FORMS_NEWSLETTER) {

//           if (storedFormData && storedFormData.email) {
//             //////console.error("Using stored email:", storedFormData.email);

//             const data = {
//               tokens: [REVINATE_TOKEN],
//               contacts: [{
//                 email: storedFormData.email
//               }]
//             };

//             //////console.error("Submitting contact data:", data);
//             submitContact(data);
//           } else {
//             ////console.error("No stored email found for form:", formId);
//           }
//         }
//       });
//     }

//     // Listen for gform_post_render event which happens after the form is loaded
//     if (window.jQuery) {
//       jQuery(document).on('gform_post_render', function(event, formId, currentPage) {
//         //////console.error("Form rendered with ID:", formId);

//         // Find the form element
//         const formElement = document.getElementById('gform_' + formId);
//         if (formElement) {
//           // Find the email field
//           const emailField = formElement.querySelector('input[type="email"]');

//           if (emailField) {
//             //////console.error("Found email field in form:", formId);

//             // Add event listeners to capture the value when it changes
//             emailField.addEventListener('change', function() {
//               //////console.error("Email field changed:", this.value);
//               storedFormData = {
//                 formId: formId.toString(),
//                 email: this.value
//               };
//             });

//             emailField.addEventListener('input', function() {
//               storedFormData = {
//                 formId: formId.toString(),
//                 email: this.value
//               };
//             });
//           }

//           // Also add listeners to the form itself
//           formElement.addEventListener('submit', function(e) {
//             //////console.error("Form submit event captured for ID:", formId);

//             // Get the email field value at submission time
//             const emailField = this.querySelector('input[type="email"]');
//             if (emailField && emailField.value) {
//               storedFormData = {
//                 formId: formId.toString(),
//                 email: emailField.value
//               };
//               //////console.error("Email captured on submit:", storedFormData.email);
//             }
//           });
//         }
//       });
//     }

//     //////console.error("Revinate contact script initialized for Gravity Forms");
//   });
